import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';
import { useAuth } from './AuthContext';
import { useSubscription } from './SubscriptionContext';
import api from '../services/api';

const TriggerContext = createContext(null);

export function TriggerProvider({ children }) {
  const { user } = useAuth();
  const { tier } = useSubscription();
  const [triggers, setTriggers] = useState([]);
  const [sessionState, setSessionState] = useState({ incorrectCount: 0, correctAgain: false });

  const fetchTriggers = useCallback(async (extraContext = {}) => {
    if (!user || tier !== 'free') { setTriggers([]); return; }
    try {
      const params = new URLSearchParams({ incorrectCount: sessionState.incorrectCount.toString(), correctAgain: sessionState.correctAgain.toString(), ...extraContext });
      const res = await api.get(`/api/triggers/evaluate?${params}`);
      if (res.data.success) setTriggers(res.data.data);
    } catch (err) { console.error('Failed to fetch triggers:', err); }
  }, [user, tier, sessionState]);

  useEffect(() => { if (user && tier === 'free') fetchTriggers(); }, [user, tier]); // eslint-disable-line react-hooks/exhaustive-deps

  const dismissTrigger = useCallback(async (triggerId) => {
    try { await api.post(`/api/triggers/${triggerId}/dismiss`); setTriggers(prev => prev.filter(t => t.triggerId !== triggerId)); } catch (err) { console.error('Dismiss failed:', err); }
  }, []);

  const clickTrigger = useCallback(async (triggerId) => {
    try { await api.post(`/api/triggers/${triggerId}/clicked`); } catch (err) { console.error('Click track failed:', err); }
  }, []);

  const recordIncorrect = useCallback(() => { setSessionState(prev => ({ ...prev, incorrectCount: prev.incorrectCount + 1 })); }, []);
  const recordCorrectAgain = useCallback(() => { setSessionState(prev => ({ ...prev, correctAgain: true })); }, []);
  const getTriggersByPlacement = useCallback((placement) => { return triggers.filter(t => t.placement === placement); }, [triggers]);

  return (
    <TriggerContext.Provider value={{ triggers, fetchTriggers, dismissTrigger, clickTrigger, getTriggersByPlacement, recordIncorrect, recordCorrectAgain }}>
      {children}
    </TriggerContext.Provider>
  );
}

export const useTriggers = () => useContext(TriggerContext);
